export default __webpack_public_path__ + "static/media/Partner Ad-Football.375223e2.pdf";